var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7753 11.0553L9.08864 0.301508C8.98876 0.201005 8.78901 0.100503 8.68914 0.100503L0.599251 0C0.299625 0 0 0.301508 0 0.603015L0.0998752 8.24121C0.0998752 8.44221 0.19975 8.54271 0.299625 8.74372L11.2859 19.799C11.3858 19.8995 11.5855 20 11.6854 20C11.8851 20 11.985 19.8995 12.0849 19.799L19.7753 12.0603C20.0749 11.7588 20.0749 11.3568 19.7753 11.0553ZM11.6854 18.794L1.09863 8.0402L0.998752 1.00503L8.48939 1.10553L18.8764 11.5578L11.6854 18.794ZM4.39451 4.52261C3.79526 5.12563 3.79526 6.13065 4.39451 6.73367C4.99376 7.33668 5.99251 7.33668 6.59176 6.73367C7.19101 6.13065 7.19101 5.12563 6.59176 4.52261C6.09238 3.9196 5.09363 3.9196 4.39451 4.52261Z",
    fill: "#818181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.69e21c5c5bec516c8b7a974b6165878c.svg";
export { ForwardRef as ReactComponent };